import { render, staticRenderFns } from "./ListInsts.vue?vue&type=template&id=62f52b75&scoped=true&"
import script from "./ListInsts.vue?vue&type=script&lang=js&"
export * from "./ListInsts.vue?vue&type=script&lang=js&"
import style0 from "./ListInsts.vue?vue&type=style&index=0&id=62f52b75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f52b75",
  null
  
)

export default component.exports